import { constant, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { marked } from 'marked';
import { DangerouslySetInnerHTML } from '../froala-dangerously-set-inner-html';
import { jsx as _jsx } from "react/jsx-runtime";
var aTagStartRegex = /<a[^>]* href="/;
var imgUrlRegex = /https?:\/\/[^>"']*?\.(?:gif|jpe?g|tiff?|png|webp|bmpg)/g;
var imgLinkRegex = new RegExp(aTagStartRegex.source + imgUrlRegex.source + '">' + imgUrlRegex.source + '</a>', 'g');
export var wrapImageInLink = function wrapImageInLink(matchedStr) {
  return pipe(matchedStr.match('"' + imgUrlRegex.source + '"'), O.fromNullable, O.map(function (match) {
    return match[0];
  }), O.match(constant(matchedStr), function (url) {
    return "<a href=".concat(url, " class=\"img-link\"><img src=").concat(url, "></img></a>");
  }));
};
var videoUrlRegex = /https?:\/\/[^>"']*?\.(?:mp4|mov|wmv|avi)/g;
var videoLinkRegex = new RegExp(aTagStartRegex.source + videoUrlRegex.source + '">' + videoUrlRegex.source + '</a>', 'g');
export var wrapVideoInLink = function wrapVideoInLink(matchedStr) {
  return pipe(matchedStr.match('"' + videoUrlRegex.source + '"'), O.fromNullable, O.map(function (match) {
    return match[0];
  }), O.match(constant(matchedStr), function (url) {
    return "<a href=".concat(url, " class=\"video-link\"><video src=").concat(url, "></video></a>");
  }));
};
var allFileUrlRegex = /https?:\/\/[^>"']*?\.(?:key|odp|pps|ppt|pdf|ods|xlr|xls|xlsx|doc|docx|odt|rtf|tex|txt|wks|wps|wpd)/g;
export var handleUrlWhitespaces = function handleUrlWhitespaces(url) {
  return url.replaceAll(' ', '%20');
};
export var formattedDescription = function formattedDescription(description, formatWithMarked) {
  return pipe(description, function (d) {
    return d.replaceAll(imgUrlRegex, handleUrlWhitespaces);
  }, function (d) {
    return d.replaceAll(videoUrlRegex, handleUrlWhitespaces);
  }, function (d) {
    return d.replaceAll(allFileUrlRegex, handleUrlWhitespaces);
  }, function (d) {
    return formatWithMarked ? marked.parseInline(d, {
      breaks: true,
      gfm: true
    }) : d;
  }, function (d) {
    return d.replaceAll(': ', ':<br>');
  }, function (d) {
    return d.replaceAll(imgLinkRegex, wrapImageInLink);
  }, function (d) {
    return d.replaceAll(videoLinkRegex, wrapVideoInLink);
  }, function (d) {
    return d.replaceAll(/<a href="https?/g, '<a target="_blank" rel="noopener noreferrer" href="https');
  });
};
export var MediaHtml = function MediaHtml(_ref) {
  var description = _ref.description,
      _ref$formatWithMarked = _ref.formatWithMarked,
      formatWithMarked = _ref$formatWithMarked === void 0 ? false : _ref$formatWithMarked;
  return /*#__PURE__*/_jsx(DangerouslySetInnerHTML, {
    sx: {
      '& p': {
        m: 0,
        display: 'inline'
      },
      '& a': {
        color: function color(t) {
          return t.palette.primary.main;
        },
        textDecoration: 'none',
        wordBreak: 'break-all',
        '&:hover': {
          textDecoration: 'underline'
        }
      },
      '& .video-link, & .img-link': {
        display: 'inline-flex'
      },
      '& video, & img': {
        maxWidth: 270,
        maxHeight: 270,
        display: 'inline-block',
        width: 1
      },
      '& .img-link': {
        mb: 1
      }
    },
    body: formattedDescription(description, formatWithMarked),
    "data-element": "DangerouslySetInnerHTML",
    "data-component": "MediaHtml",
    "data-source-file": "index.tsx"
  });
};